export class Breadcrumb {
  constructor(
    public label: string,
    public url: string,
    public isActive: boolean,
    public sequence: number,
  ) {
  }
}
